export const isObject = value => {
	return Object.prototype.toString.call(value) === '[object Object]'
}

/**
 * 
 * Get the reference of a value from deep array or object
 * 
 * @param {Array | Object} input - Input object or array
 * @param {String} path - Dotten path of which value to get 
 */
 export const deepGet = (input, path) => {
	let i
	path = path.split('.');
	for (i = 0; i < path.length; i++)
		input = input[path[i]];
	return input
}

/**
 * 
 * Set value of deep array or object
 * 
 * @param {Array | Object} input - Input object or array
 * @param {String} path - Dotten path of where to set 
 * @param {Any} value - Value to set in specified path
 */
export const deepSet = (input, path, value) => {
	let i/*, originalInput = input; */
	path = path.split('.');
	for (i = 0; i < path.length - 1; i++)
		input = input[path[i]];
	input[path[i]] = value;
	// return originalInput
}

export function array(input) {

}

array.empty = (len, value) => {
	return value ? [...Array(len)].map(_ => value) : [...Array(len).keys()]
}

export const uid = (len = 10) => {
	return Math.random().toString(36).slice(-len)
}

const classify = (...classes) => {
	return classes.map(classs => {
		if (typeof classs === 'string') return classs
		classs = Array.isArray(classs)
			? classs.map(cls => classify(cls))
			: Object.keys(classs).filter(key => classs[key])
		return classs.join(' ').trim()
	}).join(' ').trim()
}

export { classify }